import script from "./TraficPlanPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TraficPlanPage.vue?vue&type=script&setup=true&lang=ts"

import "./TraficPlanPage.vue?vue&type=style&index=0&id=7f7fa41a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f7fa41a"]])

export default __exports__